import { isYoutubeUrl } from 'features/software/utils'
import { YoutubeVideoBlock } from 'features/software/YoutubeVideoBlock'
import { cn } from 'utils/cn'

type Props = {
  urls: string[]
  title: string
  className?: string
}

export const YoutubeVideos = ({ urls, title, className }: Props) => {
  const filteredUrls: string[] = urls.filter(isYoutubeUrl)
  if (!filteredUrls.length) return null
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="text-lg font-light -mt-0.5">{title}</div>
      <div className="flex flex-col gap-4 bg-white">
        {filteredUrls.map((url, i) => {
          return <YoutubeVideoBlock url={url} key={url + i} />
        })}
      </div>
    </div>
  )
}
